<template>
    <router-view></router-view>
</template>

<style scoped>
nav {
  padding: 1rem;
  background: #333;
  text-align: center;
}

nav a {
  color: white;
  margin: 0 10px;
  text-decoration: none;
  font-size: 18px;
}

nav a:hover {
  text-decoration: underline;
}
</style>
